module.exports = __webpack_public_path__ + "static/media/tti_new_opportunity_connect.eff9a6eb.png";